import styles from './styles.module.scss';

export const CallCenter = () => (
  <div className={styles.callCenter}>
    <span className={styles.title}>Call center:</span>
    <a href="tel:+77089128007" className={styles.value}>
      <span className={styles.mark}>+7 708 </span>
      912 80 07
    </a>
  </div>
);
